import { Search, X } from "lucide-react";

export const CampaignSearch = ({ value, onChange, testId = "campaign-search-input" }) => (
  <div className="relative w-full sm:w-64">
    <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 pointer-events-none" />
    <input
      data-testid={testId}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Search campaigns…"
      className="w-full h-8 pl-8 pr-8 rounded-full bg-slate-900/60 border border-slate-800 text-xs text-slate-200 placeholder:text-slate-500 focus:outline-none focus:border-slate-600 transition-colors"
    />
    {value && (
      <button data-testid="campaign-search-clear" onClick={() => onChange("")} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-200">
        <X size={13} />
      </button>
    )}
  </div>
);
